<template>
  <div class="rf-toast-container fixed top-0 left-1/2">
    <TransitionGroup
      class="rf-toast-container--stack absolute left-1/2 mt-6 flex flex-col-reverse gap-5"
      tag="div"
    >
      <RfBaseToast
        v-for="toast in toasts"
        :key="toast.id"
        :data-cy="`toast--${toast.type}`"
        :[toast.type]="true"
        :title="toast.title"
        :body="toast.body"
        :action="toast.action"
        :textTransform="toast.textTransform"
        @close="$emit('close', toast.id)"
      />
    </TransitionGroup>
  </div>
</template>

<script setup>
import RfBaseToast from "@/components/toast/RfBaseToast.vue";

defineEmits(["close"]);
defineProps({ toasts: { type: Object, default: () => ({}) } });
</script>

<style lang="scss" scoped>
.rf-toast-container {
  z-index: 9999;

  &--stack {
    transform: translateX(-50%);
  }
}
</style>
